module.exports = __webpack_public_path__ + "static/img/charm_level_83.84a78b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/charm_level_83.png
// module id = TBXy
// module chunks = 0